import { useFormikContext } from 'formik';
import { Dispatch, memo, SetStateAction, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { AirportConfigurationType } from '../../../../backend';
import { ConfigurationsPageFormValues } from '../../../pages/ConfigurationPage';
import { StyledBox } from './ConfigurationFieldsLineContainer.style';
import { ConfigurationLineContainer } from './LineContainer/ConfigurationLineContainer';

export const ConfigurationFieldsLineContainer = memo(function ConfigurationFieldsLineContainer({
    configurationType,
    search,
    arrayReplace,
    arrayRemove,
    selectedConfigurations,
    setSelectedConfigurations,
}: {
    configurationType: AirportConfigurationType;
    search: string;
    arrayReplace: (index: number, value: any) => void;
    arrayRemove: (index: number) => void;
    selectedConfigurations: number[];
    setSelectedConfigurations: Dispatch<SetStateAction<number[]>>;
}) {
    const { values } = useFormikContext<ConfigurationsPageFormValues>();

    const filteredElements = useMemo(
        () =>
            values.configurations?.filter(
                c =>
                    c.type === AirportConfigurationType.AIRLINES &&
                    (c.content?.name?.includes(search) ||
                        c.content?.codeIata?.includes(search) ||
                        c.content?.codeIcao?.includes(search)),
            ),
        [search, values.configurations],
    );

    if (!filteredElements) return null;

    if (filteredElements.length === 0) {
        return (
            <StyledBox p={5} color={'white'} fontSize={'24px'} fontWeight={'400'}>
                <FormattedMessage id={'configurationsForm.noOptions'} />
            </StyledBox>
        );
    }
    return (
        <StyledBox>
            {filteredElements.map(resource => (
                <ConfigurationLineContainer
                    arrayRemove={arrayRemove}
                    arrayReplace={arrayReplace}
                    key={values.configurations.indexOf(resource)}
                    configurationType={configurationType}
                    index={values.configurations.indexOf(resource)}
                    selectedConfigurations={selectedConfigurations}
                    setSelectedConfigurations={setSelectedConfigurations}
                />
            ))}
        </StyledBox>
    );
});
